<div oui-dialog-title>
  {{ title ?? 'Confirmation' }}
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>
<oui-dialog-content>
  <div class="flex-vertical flex-center">
    @if (isMutating) {
      <oui-loading size="small"></oui-loading>
    }
  </div>

  @if (!isMutating) {
    <div class="flex-vertical gap-16">
      <div class="body-1">{{ message }}</div>
      @if (data?.isReject) {
        <oui-select
          [multiple]="false"
          [options]="motifRejetOptions"
          [control]="motifRejet"
          placeholder="Motif"
          label="Motif">
        </oui-select>
      }
      @if (!data?.isReject) {
        <oui-select
          [multiple]="false"
          [options]="motifAnnulationOptions"
          [control]="motifAnnulation"
          placeholder="Motif"
          label="Motif">
        </oui-select>
      }
      <oui-textarea label="Commentaire" placeholder="Commentaire" [control]="comment"></oui-textarea>
    </div>
  }
</oui-dialog-content>
<oui-dialog-actions>
  <oui-button type="text" (click)="onCancel()"> Annuler </oui-button>
  <oui-button type="contained" (click)="onValidate()" [disabled]="!canValidate || isMutating">
    {{ 'Valider' }}
  </oui-button>
</oui-dialog-actions>
